import { FC, useCallback, useEffect, useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { DebouncedInput } from "./DebouncedInput";
import type { GridApi } from "ag-grid-community";

interface AgGridGlobalSearchProps extends Omit<TextFieldProps, "onChange"> {
  searchValue?: string;
  gridApi: GridApi | null;
  size?: "small" | "medium" | "xsmall";
}

export const AgGridGlobalSearch: FC<AgGridGlobalSearchProps> = ({
  gridApi,
  searchValue,
  size = "xsmall",
  ...textFieldProps
}) => {
  const [search, setSearch] = useState("");

  const searchChangeHandler = useCallback(
    (keyword: string | number) => {
      gridApi?.setGridOption("quickFilterText", `${keyword}`);
      setSearch(`${keyword}`);
    },
    [gridApi],
  );

  useEffect(() => {
    searchValue && searchChangeHandler(searchValue);
  }, [searchValue, searchChangeHandler]);

  return (
    <DebouncedInput
      size={size}
      placeholder="Search"
      type="search"
      value={search}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      onChange={searchChangeHandler}
      {...textFieldProps}
    />
  );
};
